import React from 'react'
import InventoryProductsContainer from '../../containers/inventorymng/InventoryProductsContainer'



const InventoryProductsPage = () => {


    return (
        <div>
            <InventoryProductsContainer />
        </div>
    )
}

export default InventoryProductsPage